var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.AppHeaderV2,{staticClass:"sticky top-0 left-0 right-0 h-14 z-10"}),_vm._v(" "),_c('nuxt',{staticClass:"overflow-x-hidden"}),_vm._v(" "),_c(_setup.AppFooterMenu)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }